import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import LpgContinueSolid from "@/icons/Lpg/ContinueSolid";
import { Icon } from "../Icon";

import styles from "./DirectionButton.scss";

export const DirectionButton = forwardRef(
  ({ children, small, direction, onClick, tag: CustomTag, ...others }, ref) => {
    const buttonClasses = classNames(styles["direction-button"], {
      [styles["direction-button--indented"]]:
        direction === "forward" || direction === "none",
      [styles["direction-button--magenta"]]: direction === "backward",
      [styles["direction-button--small"]]: small,
    });

    const iconClasses = classNames({
      [styles["direction-button__icon--inverted"]]: direction === "backward",
      [styles["direction-button__icon"]]: direction === "forward",
    });
    return (
      <CustomTag
        ref={ref}
        type="button"
        onClick={onClick}
        className={buttonClasses}
        {...others}
      >
        {direction === "backward" && (
          <span className={iconClasses}>
            <Icon size={Icon.Size.parent} icon={LpgContinueSolid} />
          </span>
        )}
        {children}
        {direction === "forward" && (
          <span className={iconClasses}>
            <Icon size={Icon.Size.parent} icon={LpgContinueSolid} />
          </span>
        )}
      </CustomTag>
    );
  }
);

DirectionButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  small: PropTypes.bool,
  direction: PropTypes.oneOf(["backward", "forward", "none"]),
  onClick: PropTypes.func,
  tag: PropTypes.string,
};

DirectionButton.defaultProps = {
  small: false,
  onClick: null,
  direction: "forward",
  tag: "button",
};

DirectionButton.displayName = "DirectionButton";

export default DirectionButton;
